define('companiesLinkView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'template!companiesLinkView'
], function (
  Module,
  App,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  // Small clickable block: the company a customer is linked to, with its total
  // order amount and number of linked customers. Shown in the order/offer header
  // and the customer page. Reads the company.* fields off the customer model
  // (EndUserJson). Clicking opens the company detail.
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'companies-link-view',

    events: {
      'click': 'onClick'
    },

    modelEvents: {
      'change:companySecId': 'render',
      'change:companyName': 'render',
      'change:companyOrderAmount': 'render',
      'change:companyNbrEndUsers': 'render',
      'change:companyHasComment': 'render'
    },

    serializeData: function () {
      var amount = this.model.get('companyOrderAmount');
      var nbr = this.model.get('companyNbrEndUsers');
      return {
        hasCompany: !!this.model.get('companySecId'),
        hasComment: !!this.model.get('companyHasComment'),
        name: this.model.get('companyName') || '',
        orderAmount: (amount === null || amount === undefined) ? 0 : amount,
        nbrEndUsers: (nbr === null || nbr === undefined) ? 0 : nbr,
        amountLabel: _.i18n('companies.orderAmount', null, 'Orders total'),
        customersLabel: _.i18n('companies.nbrEndUsers', null, 'Sub-accounts'),
        commentLabel: _.i18n('companies.hasComment', null, 'This company has a comment')
      };
    },

    onRender: function () {
      if (this.model.get('companySecId')) {
        this.$el.css('display', 'flex');
      } else {
        this.$el.hide();
      }
    },

    onClick: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var secId = this.model.get('companySecId');
      if (secId) {
        App.trigger('companies:show', secId);
      }
    }
  });
});

